import styled from 'styled-components'

export const Footer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;

  margin-bottom: 16px;
`
